// extracted by mini-css-extract-plugin
export default {"carousel_container":"CardVideoPlayer_carousel_container__dfXg2","section_video_cards":"CardVideoPlayer_section_video_cards__No4Vv","trailer":"CardVideoPlayer_trailer__9aj-V"};